module.exports = __webpack_public_path__ + "static/media/main.fcf98068.png";